import { useEffect } from "react";
import { Link } from "react-router-dom";
import { breadcrumbLd, setJsonLd } from "@/lib/api";

export const Breadcrumbs = ({ items, light = false, className = "" }) => {
  const key = items.map((i) => i[1]).join("|");
  useEffect(() => setJsonLd("breadcrumb-jsonld", breadcrumbLd(items)), [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={`font-mono-label ${light ? "text-white/50" : "text-ink/50"} ${className}`}>
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1">
        {items.map(([name, url], i) => (
          <li key={url} className="flex items-center gap-2">
            {i > 0 && <span aria-hidden="true" className="opacity-50">/</span>}
            {i < items.length - 1 ? (
              <Link to={url} className={`uppercase transition-colors ${light ? "hover:text-white" : "hover:text-ink"}`}>
                {name}
              </Link>
            ) : (
              <span aria-current="page" className={light ? "text-white/80" : "text-ink/80"}>{name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
